var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90822 1.71947C8.82575 0.0883032 11.1743 0.0883023 12.0918 1.71947L18.7882 13.6241C19.6881 15.224 18.532 17.2007 16.6964 17.2007H3.30364C1.46806 17.2007 0.311944 15.224 1.21186 13.6241L7.90822 1.71947ZM11.1999 13.6009C11.1999 14.2636 10.6626 14.8009 9.9999 14.8009C9.33716 14.8009 8.7999 14.2636 8.7999 13.6009C8.7999 12.9381 9.33716 12.4009 9.9999 12.4009C10.6626 12.4009 11.1999 12.9381 11.1999 13.6009ZM9.9999 4.00088C9.33716 4.00088 8.7999 4.53814 8.7999 5.20088V8.80088C8.7999 9.46362 9.33716 10.0009 9.9999 10.0009C10.6626 10.0009 11.1999 9.46362 11.1999 8.80088V5.20088C11.1999 4.53814 10.6626 4.00088 9.9999 4.00088Z",
    fill: "#CB3A31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.62924d7c48982d3a55d7cdf4d6c51fa4.svg";
export { ForwardRef as ReactComponent };